export const COOKIE_STORAGE_PREFIX = 'cookies-agreed-sellers-external-HC';
export const WARNING_COOKIES_PORTAL_PREFIX = 'warning-cookies-modal';

export const GE_ZONE_PROD = '.wildberries.ge';
export const GE_ZONE_STAGE = '-ru.wb.ge';

export const PRO_WB_RU = 'https://pro.wildberries.ru';
export const PRO_WB_CN = 'https://pro.wildberries.cn';

export const LANDING_URL = 'https://seller.wildberries.ru/about-portal';
export const WB_ROOT = 'https://seller.wildberries.ru';
